<template>
  <div class="container">
    <h1 class="title-data-h1 text-center">Atualize os dados para finalizar sua assinatura</h1>
    <br>
    <div class="container-no-top-bottom">
      <!-- <div class="columns is-multiline"> -->
        <div class="column is-3"></div>
        <div class="column is-12">
          <div class="columns is-multiline">
            <div class="column is-5">
              <label for>Escolha o plano</label>
              <v-select class="background-select" v-model="userData.plan" :options="plans"></v-select>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="columns is-multiline">
            <div class="column is-3">
              <t-input
                :placeholder="'Nome'"
                :name="'nome'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.name"
                :verifiyError="$v.userData.sender.name.$error"
                @blur="$v.userData.sender.name.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.name.$error">
                <ul class="contactForm__messages">
                  <li v-if="!$v.userData.sender.name.required">* O campo nome é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-2">
              <t-input
                :placeholder="'Data nascimento'"
                :name="'nascimento'"
                :classIcon="'fas fa-user'"
                v-model="userData.paymentMethod.creditCard.holder.birthDate"
                :verifiyError="$v.userData.paymentMethod.creditCard.holder.birthDate.$error"
                @blur="$v.userData.sender.$touch()"
              />
              <div
                class="errors-form-messages"
                v-if="$v.userData.paymentMethod.creditCard.holder.birthDate.$error"
              >
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.paymentMethod.creditCard.holder.birthDate.required"
                  >* O campo nome é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <t-input
                :placeholder="'Email'"
                :name="'email'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.email"
                :verifiyError="$v.userData.sender.email.$error"
                @blur="$v.userData.sender.email.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.email.$error">
                <ul class="contactForm__messages">
                  <li v-if="!$v.userData.sender.email.required">* O campo email é obrigatório.</li>
                  <li v-if="!$v.userData.sender.email.email">* Preencha um email válido.</li>
                </ul>
              </div>
            </div>
            <div class="column is-4">
              <div class="columns">
                <div class="column is-6">
                  <t-input
                    :placeholder="'CPF'"
                    :name="'cpf'"
                    :classIcon="'fas fa-user'"
                    v-mask="'###.###.###-##'"
                    v-model="userData.sender.documents[0].value"
                  />
                  <!-- <div class="errors-form-messages" v-if="$v.userData.sender.documents.value.$error">
                    <ul class="contactForm__messages">
                      <li v-if="!$v.userData.sender.documents.value.required">* O campo CPF é obrigatório.</li>
                    </ul>
                  </div>-->
                </div>
                <div class="column is-6">
                  <t-input
                    :placeholder="'Telefone'"
                    :name="'phone'"
                    :classIcon="'fas fa-user'"
                    v-mask="['(##) ####-####','(##) #####-####']"
                    v-model="userData.sender.phone.number"
                    :verifiyError="$v.userData.sender.phone.number.$error"
                    @blur="$v.userData.$touch()"
                  />
                  <div class="errors-form-messages" v-if="$v.userData.sender.phone.number.$error">
                    <ul class="contactForm__messages">
                      <li
                        v-if="!$v.userData.sender.phone.number.required"
                      >* O campo Telefone é obrigatório.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <t-input
                :placeholder="'Endereço'"
                :name="'endereco'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.street"
                :verifiyError="$v.userData.sender.address.street.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.street.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.street.required"
                  >* O campo Endereço é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-2">
              <t-input
                :placeholder="'Número'"
                :name="'numero'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.number"
                :verifiyError="$v.userData.sender.address.number.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.number.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.number.required"
                  >* O campo número é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <t-input
                :placeholder="'Complemento'"
                :name="'complemento'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.complement"
                :verifiyError="$v.userData.sender.address.complement.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.complement.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.complement.required"
                  >* O campo complemento é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <t-input
                :placeholder="'Bairro'"
                :name="'bairro'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.district"
                :verifiyError="$v.userData.sender.address.district.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.district.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.district.required"
                  >* O campo bairro é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <t-input
                :placeholder="'Cidade'"
                :name="'cidade'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.city"
                :verifiyError="$v.userData.sender.address.city.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.city.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.city.required"
                  >* O campo cidade é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <v-select
                class="background-select"
                v-model="userData.sender.address.state"
                :options="states"
                :verifiyError="$v.userData.sender.address.state.$error"
                @blur="$v.userData.sender.address.$touch()"
              ></v-select>
              <!-- <t-input
                :placeholder="'Estado'"
                :name="'estado'"
                :classIcon="'fas fa-user'"
                v-model="userData.sender.address.state"
                :verifiyError="$v.userData.sender.address.state.$error"
                @blur="$v.userData.sender.address.$touch()"
              /> -->
              <div class="errors-form-messages" v-if="$v.userData.sender.address.state.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.state.required"
                  >* O campo estado é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <t-input
                :placeholder="'CEP'"
                :name="'cep'"
                :classIcon="'fas fa-user'"
                v-mask="'#####-###'"
                v-model="userData.sender.address.postalCode"
                :verifiyError="$v.userData.sender.address.postalCode.$error"
                @blur="$v.userData.sender.address.$touch()"
              />
              <div class="errors-form-messages" v-if="$v.userData.sender.address.postalCode.$error">
                <ul class="contactForm__messages">
                  <li
                    v-if="!$v.userData.sender.address.postalCode.required"
                  >* O campo CEP é obrigatório.</li>
                </ul>
              </div>
            </div>
            <div class="column is-3">
              <v-select class="background-select" v-model="plan" :options="plans"></v-select>
            </div>
            <div class="column is-12">
              <VueCardPayment
                v-model="payment"
                :settings="settings"
                @card-submit="registerDataStudent(userData,payment)"
              ></VueCardPayment>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import TInput from '@/components/TInput.vue'
import notification from '@/support/mixins/notifications.mixin'
import formErrors from '@/support/mixins/form-errors.mixin'
import PlanService from '@/services/plan/Plan'
import formatter from '@/support/mixins/formatter.mixin'
import estados from './estados.js'
export default {
  mixins: [notification, formErrors, formatter],
  components: {
    TInput
  },
  data () {
    return {
      planService: new PlanService(),
      plans: [],
      plan: { label: 'Plano', value: '' },
      payment: '',
      states: estados,
      settings: {
        labels: {
          cardNumber: 'Número do cartão',
          month: 'Mês',
          year: 'Ano',
          cardHolder: 'Nome',
          button: 'Assinar'
        },
        placeholders: {
          cardNumber: '0000 0000 0000 0000',
          month: '00',
          year: '00',
          cardHolder: 'JOHN DOE',
          cvv: '000'
        },
        showBank: true,
        showPaymentSystem: true
      },
      brand: '',
      token: '',
      userData: {
        sender: {
          address: {
            country: 'BRA'
          },
          documents: [{
            type: 'CPF',
            value: ''
          }],
          phone: {}
        },
        paymentMethod: {
          type: 'CREDITCARD',
          creditCard: {
            holder: {
              phone: {},
              documents: [
                {
                  type: 'CPF',
                  value: ''
                }
              ]
            }
          }
        }
      },
      filterOne: ''
    }
  },
  mounted () {
    this.getSession()
    this.listPlans()
  },
  methods: {
    listPlans () {
      this.planService
        .list()
        .then(result => {
          this.plans = this.preparePlans(result.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    preparePlans (plans) {
      return plans.map(plan => ({
        label: `${plan.name} - R$${plan.value}`,
        value: plan.code
      }))
    },
    registerDataStudent (paymentData) {
      console.log(paymentData)
      const ultimo = paymentData.sender.phone.number.length
      const ddd = paymentData.sender.phone.number.substring(0, 2)
      const phone = paymentData.sender.phone.number.substring(2, ultimo)
      paymentData.sender.phone.number = phone
      paymentData.sender.phone.areaCode = ddd
      paymentData.paymentMethod.creditCard.holder.phone.number = phone
      paymentData.paymentMethod.creditCard.holder.phone.areaCode = ddd
      paymentData.paymentMethod.creditCard.holder.documents = paymentData.sender.documents
      paymentData.plan = this.plan.value
      paymentData.sender.address.state = paymentData.sender.address.state.value
      this.getBrand()
      this.getSenderHash()
      paymentData.paymentMethod.creditCard.token = this.token
      paymentData.paymentMethod.creditCard.holder.name = this.teste.name
      const fields = [this.$v.userData]
      this.verifyErrorsForm(fields)
        .then(() => {
          this.planService
            .payPreApproval(paymentData)
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log('Erro no pagamento => ', error)
            })
          console.log('OBJETO PRONTO => ', paymentData)
        })
        .catch(err => {
          this.errorMsg('Usuário', 'Erro Maligno' + err, 'topCenter')
        })
    },
    getSenderHash () {
      const self = this
      PagSeguroDirectPayment.onSenderHashReady(function (response) {
        if (response.status === 'error') {
          console.log(response.message)
          return false
        }
        self.userData.sender.hash = response.senderHash // Hash estará disponível nesta variável.
      })
    },
    getBrand () {
      this.teste.number = this.teste.number.replace(' ', '')
      const cardBin = this.teste.number.substring(0)
      const self = this
      PagSeguroDirectPayment.getBrand({
        cardBin,
        success: function (response) {
          self.getCardToken(response.brand.name)
        },
        error: function (response) {
          console.log(response)
        },
        complete: function (response) {}
      })
    },
    getCardToken (brand) {
      const self = this
      this.bran = brand
      console.log('Brand => ', brand)
      PagSeguroDirectPayment.createCardToken({
        cardNumber: '4111111111111111', // Número do cartão de crédito
        brand: brand, // Bandeira do cartão
        cvv: '123', // CVV do cartão
        expirationMonth: '12', // Mês da expiração do cartão
        expirationYear: '2030', // Ano da expiração do cartão, é necessário os 4 dígitos.
        success: function (response) {
          self.token = response.card.token
        },
        error: function (response) {
          console.log(response)
        },
        complete: function (response) {
          // Callback para todas chamadas.
        }
      })
    },
    getSession () {
      this.planService
        .getSession()
        .then(response => {
          console.log(response)
          PagSeguroDirectPayment.setSessionId(response.data.session.id)
        })
        .catch(error => {
          console.log(error)
        })
    },
    setSelected (value) {
      return value.value
    }
  },
  validations: {
    userData: {
      sender: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        phone: {
          number: {
            required
          }
        },
        address: {
          street: {
            required
          },
          number: {
            required
          },
          complement: {
            required
          },
          district: {
            required
          },
          city: {
            required
          },
          state: {
            required
          },
          country: {
            required
          },
          postalCode: {
            required
          }
        },
        documents: {
          value: {
            required
          }
        }
      },
      paymentMethod: {
        creditCard: {
          holder: {
            birthDate: {
              required
            }
          }
        }
      }
    }
  }
}
</script>
<style >
.title-data-h1 {
  font-size: 1.5rem;
  font-weight: 500;
}
.radio-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .cardWrap {
    width: 100%;
    padding: 0;
  }
  .cardWrap button {
    width: 100px !important;
  }
}
</style>
